import { api } from '../core';
import { CASE_OVERVIEW_TAG } from '../constants';
import { setCaseOverview } from '@/store';

export interface BundleInfo {
  bundleId: string;
  createdAt: string;
  lastUpdated: string;
  numberOfPages: number;
}

export interface EntryInfo {
  createdAt: string;
  lastUpdated: string;
  numberOfEntries: number;
}

export interface CaseOverviewResponse {
  chronology: EntryInfo;
  fullBundle: BundleInfo;
  lightBundle: BundleInfo;
  timeline: EntryInfo;
}

type CaseOverviewProps = {
  abortController?: AbortController;
  caseId: string;
};

const caseOverviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseOverview: builder.query<CaseOverviewResponse, CaseOverviewProps>({
      query: ({ abortController = new AbortController(), caseId }: CaseOverviewProps) => ({
        url: `case/overview?case_id=${caseId}`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: (_result, _err, { caseId }) => [{ type: CASE_OVERVIEW_TAG, id: caseId }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setCaseOverview(data));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseOverview in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 3 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetCaseOverviewQuery } = caseOverviewApi;
